module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAtCAYAAAAHiIP8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJVJREFUeNrs18EJgCAYhmFrgkZohEaoDRrBFZrIURqhNrEN6g8qSARPHj54f3gvHYwH9aBzTHG8FdQB51NQB7yN6gAPAAAAAAAAAAAAAAAAAKoAhb6ZRQE/RGdtiogmOU43ZLWG5Pti7Ur3IrcjMQMDAgQIECBAgAABAgQIEHlIW2HNw5rUXoKlHZE8Timkr/2TS4ABAAydPUigj//UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back.png
// module id = DtD7
// module chunks = 1